import is from "./filter-set.js";
export default class us {
  constructor(t, s) {
    (this.productId = t), (this.tf = s), (this.productId = t), (this.tf = s);
  }
  xc(t) {
    if (null == this.productId || null == this.tf) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.tf.xc(i);
  }
  static fromJson(t) {
    return new us(
      t ? t.product_id : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  bt() {
    return { id: this.productId, pf: this.tf ? this.tf.bt() : null };
  }
}
